module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "state control",
    class: (_vm.tmp.isSilence ? 'isSilence' : '') + ' ' + (_vm.tmp.isIllegibly ? 'isIllegibly' : '')
  }, [_c('div', {
    staticClass: "title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.title),
      expression: "tmp.title"
    }],
    staticClass: "answerTitle",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.title')
    },
    domProps: {
      "value": (_vm.tmp.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tmp, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "windowButtons"
  }, [_c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": _vm.$t('common.actions.delete')
    },
    on: {
      "click": function($event) {
        return _vm.remove()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wordsEditor"
  }, [_c('div', {
    staticClass: "control",
    class: _vm.tmp.isIntro ? 'hide-input' : ''
  }, [_c('label', {
    staticClass: "checkbox isSilence"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.isSilence),
      expression: "tmp.isSilence"
    }],
    staticClass: "isSilence checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tmp.isSilence) ? _vm._i(_vm.tmp.isSilence, null) > -1 : (_vm.tmp.isSilence)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tmp.isSilence,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tmp, "isSilence", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tmp, "isSilence", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tmp, "isSilence", $$c)
        }
      }
    }
  }), _vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.silence')))]), _vm._v(" "), _c('label', {
    staticClass: "checkbox isIllegibly"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.isIllegibly),
      expression: "tmp.isIllegibly"
    }],
    staticClass: "isIllegibly checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.tmp.isIllegibly) ? _vm._i(_vm.tmp.isIllegibly, null) > -1 : (_vm.tmp.isIllegibly)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tmp.isIllegibly,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tmp, "isIllegibly", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tmp, "isIllegibly", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tmp, "isIllegibly", $$c)
        }
      }
    }
  }), _vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.anotherAnswer')))])]), _vm._v(" "), _c('vue-tags', {
    class: _vm.tmp.isIntro ? 'hide-input' : '',
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var tag = ref.tag;
        var removeTag = ref.removeTag;
        var inputEventHandlers = ref.inputEventHandlers;
        var inputBindings = ref.inputBindings;

        return _c('div', {
          staticClass: "tags-input tags are-medium"
        }, [_c('div', {
          staticClass: "control autocomplete"
        }, [_c('input', _vm._g(_vm._b({
          staticClass: "tags-input-text input",
          attrs: {
            "placeholder": _vm.$t('scenarios.konstruktor.canvas.answer.synonyms.addWord') + '...'
          }
        }, 'input', inputBindings, false), inputEventHandlers))]), _vm._v(" "), _c('button', {
          staticClass: "button addForAll",
          attrs: {
            "type": "button",
            "title": _vm.$t('scenarios.konstruktor.canvas.answer.synonyms.addForAllWithSameTitle')
          },
          on: {
            "click": function($event) {
              return _vm.addWordsForAllByTitle(_vm.tmp)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-copy"
        })]), _vm._v(" "), _vm._l((_vm.tmp.tags), function(tag) {
          return _c('span', {
            staticClass: "tags-input-tag tag is-medium"
          }, [_vm._v("\n           " + _vm._s(tag) + "\n           "), _c('button', {
            staticClass: "tags-input-remove delete",
            attrs: {
              "type": "button"
            },
            on: {
              "click": function($event) {
                return removeTag(tag)
              }
            }
          })])
        })], 2)
      }
    }]),
    model: {
      value: (_vm.tmp.tags),
      callback: function($$v) {
        _vm.$set(_vm.tmp, "tags", $$v)
      },
      expression: "tmp.tags"
    }
  }), _vm._v(" "), (_vm.tmp.isIntro) ? _c('div', {
    staticClass: "button-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "button choose-state",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setApprove()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.approve')))]), _vm._v(" "), _c('button', {
    staticClass: "button choose-state",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setDeny()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.deny')))]), _vm._v(" "), _c('button', {
    staticClass: "button choose-state",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setSilence()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.silence')))]), _vm._v(" "), _c('button', {
    staticClass: "button choose-state",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setIllegibly()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.illegibly')))]), _vm._v(" "), _c('button', {
    staticClass: "button choose-state",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setCustom()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.custom')))])]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b93c4d2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/konstruktor/InOutState.vue
// module id = 564
// module chunks = 42